<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Monthly Bookings'
                    : 'Deleted Monthly Bookings'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <!-- <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col> -->
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    v-model="filter.status"
                    :items="approvalStatus"
                    label="Approval Status"
                    placeholder="Filter by Approval Status"
                    @click:clear="(filter.status = null), (page = 1)"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    @click:clear="(filter.user_id = null), (page = 1)"
                    v-model="filter.user_id"
                    :items="userItems"
                    label="User"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active User"
                    prepend-inner-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3" v-if="positionName !== 'MASTER FRANCHISEE' && positionName !== 'FRANCHISEE ADMIN'">
                  <v-autocomplete
                    ref="zone"
                    solo
                    hide-details="auto"
                    rounded
                    :loading="isMasterLoading"
                    @click:clear="(filter.zone_id = null), (page = 1)"
                    v-model="filter.zone_id"
                    :items="zoneItems"
                    label="Zone"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Zone"
                    prepend-inner-icon="mdi-map-marker"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.month_year"
                        label="Year - Month"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        solo
                        hide-details="auto"
                        rounded
                        @click:clear="filter.month_year = null"
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @change="(month_menu = false), getData()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 130px">User</th>
                      <th class="text-left" style="min-width: 95px">Month</th>
                      <th class="text-left" style="min-width: none">Year</th>
                      <th class="text-left" style="min-width: none">Zone</th>
                      <th class="text-left" style="min-width: none">Plan</th>
                      <th class="text-left" style="min-width: none">Address</th>
                      <th class="text-left" style="min-width: none">
                        Start Date
                      </th>
                      <th class="text-left" style="min-width: none">
                        End Date
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-left" style="min-width: none">Pets</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="user_monthly_job_requests.length != 0">
                    <tr
                      v-for="(
                        user_monthly_job_request, i
                      ) in user_monthly_job_requests"
                      :key="`user_monthly_job_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last':
                          user_monthly_job_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="user_monthly_job_request.status == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="user_monthly_job_request.status == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="user_monthly_job_request.status == 2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ user_monthly_job_request.user.user_name || "" }}
                      </td>
                      <td>{{ user_monthly_job_request.month || "" }}</td>
                      <td>{{ user_monthly_job_request.year || "" }}</td>
                      <td>
                        <v-select
                          v-if="positionName !== 'MASTER FRANCHISEE'"
                          :items="zoneItems"
                          item-text="text"
                          item-value="value"
                          v-model="user_monthly_job_request.zone_id"
                          @change="updateZone(user_monthly_job_request)"
                          dense
                          outlined
                          hide-details
                        ></v-select>
                        <span v-else>
                          {{ getZoneName(user_monthly_job_request.zone_id) }}
                        </span>
                      </td>
                      <td style="min-width: 220px">
                        {{
                          user_monthly_job_request.plan.no_of_dogs +
                            " Dog - " +
                            user_monthly_job_request.plan.no_of_walks +
                            " Walk " +
                            user_monthly_job_request.plan.tier || ""
                        }}
                      </td>
                      <td style="min-width: 250px">
                        {{
                          user_monthly_job_request.user_address.address || ""
                        }}
                      </td>
                      <td style="min-width: 115px">
                        {{ user_monthly_job_request.start_date || "" }}
                      </td>
                      <td style="min-width: 115px">
                        {{ user_monthly_job_request.end_date || "" }}
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(user_monthly_job_request.created_at) }}
                      </td>
                      <td style="min-width: 380px">
                        <template
                          v-if="
                            user_monthly_job_request
                              .user_monthly_job_request_pets.length
                          "
                        >
                          <v-expansion-panels class="my-2">
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                color="primary"
                                class="white--text"
                              >
                                List of Pets
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-simple-table
                                  fixed-header
                                  class="striped-table"
                                >
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th style="width: 95">Name</th>
                                        <th style="width: 95">Breed</th>
                                        <th style="width: 95">Weight</th>
                                        <th style="width: 95">Age</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          pet, uMJRP
                                        ) in user_monthly_job_request.user_monthly_job_request_pets"
                                        :key="`detail_${uMJRP}`"
                                        :class="{
                                          'table-row-even': uMJRP % 2 === 0,
                                          'table-row-odd': uMJRP % 2 !== 0,
                                          'table-row-last':
                                            user_monthly_job_request
                                              .user_monthly_job_request_pets
                                              .length -
                                              1 ==
                                            uMJRP,
                                        }"
                                      >
                                        <td>{{ pet.user_pet.name }}</td>
                                        <td>
                                          {{ pet.user_pet.breed.description }}
                                        </td>
                                        <td>{{ pet.user_pet.weight }}</td>
                                        <td>{{ pet.user_pet.age }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </template>
                        <template v-else> </template>
                      </td>
                      <td class="text-right" style="min-width: 235px">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom v-if="user_monthly_job_request.has_invoice == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="green"
                                dark
                                :loading="downloadingInvoiceId === user_monthly_job_request.id"
                                @click="downloadInvoice(user_monthly_job_request)"
                              >
                                <v-icon dark> mdi-download </v-icon>
                              </v-btn>
                            </template>
                            <span>Download Invoice</span>
                          </v-tooltip>
                          <template v-if="user_monthly_job_request.status == 1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-2"
                                  fab
                                  x-small
                                  color="primary"
                                  :to="`/daily-job-plans?user_monthly_job_request_id=${encryptIt(
                                    user_monthly_job_request.id
                                  )}`"
                                >
                                  <v-icon dark> mdi-eye </v-icon>
                                </v-btn>
                              </template>
                              <span>View Daily Plan</span>
                            </v-tooltip>
                          </template>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'monthly_bookings'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="
                                  OpenWarning(user_monthly_job_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/user-monthly-job-requests/${encryptIt(
                                  user_monthly_job_request.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'monthly_bookings'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="
                                  Restore_this(user_monthly_job_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this user_monthly_job_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row class="mt-4">
                <v-col cols="12" class="d-flex justify-space-between align-center">
                  <v-pagination rounded v-model="page" :length="paginationLength">
                  </v-pagination>
                  <v-select
                    v-model="selectedRowsPerPage"
                    :items="rowsPerPageOptions"
                    label="Rows per page"
                    dense
                    outlined
                    hide-details
                    @change="onRowsPerPageChange"
                    style="max-width: 150px;"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'monthly_bookings'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_user_monthly_job_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>UserMonthlyJobRequest deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_user_monthly_job_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_user_monthly_job_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>UserMonthlyJobRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_user_monthly_job_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-snackbar :value="!!invoiceError" @input="invoiceError = ''" :timeout="4000" color="error" rounded="pill">
        {{ invoiceError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import { fileNameFrom, saveBlob } from "../walkies-reports/reportUtils";
export default {
  name: "UserMonthlyJobRequestsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
        month_year: "",
        month: "",
        year: "",
        zone_id: "",
      },
      user_monthly_job_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      approvalStatus: [
        {
          id: 0,
          text: "PENDING",
          value: "0",
        },
        { id: "APPROVED", text: "APPROVED", value: "1" },
        { id: "REJECTED", text: "REJECTED", value: "2" },
      ],
      userItems: [],
      zoneItems: [],
      ExportUserMonthlyJobRequestTypes: [],
      page: 1,
      selectedRowsPerPage: 10,
      rowsPerPageOptions: [
        { text: "10", value: 10 },
        { text: "15", value: 15 },
        { text: "20", value: 20 },
        { text: "25", value: 25 },
        { text: "30", value: 30 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "ALL", value: -1 },
      ],
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_user_monthly_job_request: false,
      is_deleted_user_monthly_job_request: false,
      restore_user_monthly_job_request: false,
      is_restored_user_monthly_job_request: false,
      show_Warning_popUp: false,
      month_menu: false,
      isMasterLoading: false,
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
      downloadingInvoiceId: null,
      invoiceError: "",
    };
  },
  watch: {
    page: "getData",
    month_menu: "getMonthYear",
    $route() {
      this.getMasters();
    },
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async downloadInvoice(user_monthly_job_request) {
      this.downloadingInvoiceId = user_monthly_job_request.id;
      try {
        const response = await axios.get(
          `user_monthly_job_requests/${this.encryptIt(user_monthly_job_request.id)}/invoice`,
          { responseType: "blob" }
        );
        saveBlob(
          response.data,
          fileNameFrom(
            response.headers["content-disposition"],
            `Invoice_${user_monthly_job_request.id}.pdf`
          )
        );
      } catch (error) {
        // The error body is a blob too: read the API's message out of it
        let message = "Could not download the invoice.";
        try {
          message = JSON.parse(await error.response.data.text()).message || message;
        } catch (e) {
          // keep the default message
        }
        this.invoiceError = message;
      }
      this.downloadingInvoiceId = null;
    },
    async getMasters() {
      this.isMasterLoading = true;
      this.filter.franchisee_id = this.user.franchisee_id
        ? this.user.franchisee_id
        : null;
      await axios
        .get(`masters?context=user_monthly_job_requests`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.customers.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.user_name,
              value: user.id,
            });
          });
          // Zones
          if (masters.zones) {
            masters.zones.forEach((zone) => {
              this.zoneItems.push({
                id: zone.id,
                text: zone.description,
                value: zone.id,
              });
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
      this.getData();
    },
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      await axios
        .patch(`/user_monthly_job_requests/${reqID}`, selected_requested)
        .then(() => {
          this.getData();
        });
      this.show_Warning_popUp = false;
    },
    getZoneName(zoneId) {
      if (!zoneId) return "";
      const zone = this.zoneItems.find(item => item.value == zoneId);
      return zone ? zone.text : "";
    },
    async updateZone(user_monthly_job_request) {
      try {
        const reqID = this.encryptIt(user_monthly_job_request.id);
        const payload = {
          zone_id: user_monthly_job_request.zone_id
        };
        
        await axios.patch(`/user_monthly_job_requests/${reqID}`, payload);
        this.isShowPopUP("Success", "Zone updated successfully", "success");
      } catch (error) {
        console.error(error);
        this.isUnAuthorised();
      }
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      if (this.filter.month_year) {
        this.filter.year = this.filter.month_year.split("-")[0];
        this.filter.month = this.filter.month_year.split("-")[1];
      }
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.franchisee_id = this.filter.franchisee_id
        ? this.filter.franchisee_id
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.zone_id = this.filter.zone_id ? this.filter.zone_id : "";
      console.log(this.filter);
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        (this.selectedRowsPerPage === -1 ? 1000000 : this.selectedRowsPerPage) +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&status=" +
        this.filter.status +
        "&franchisee_id=" +
        this.filter.franchisee_id +
        "&user_id=" +
        this.filter.user_id +
        "&month=" +
        this.filter.month +
        "&year=" +
        this.filter.year +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword +
        (this.filter.zone_id ? "&zone_id=" + this.filter.zone_id : "");
      await axios
        .get(`user_monthly_job_requests?${query}`)
        .then((response) => {
          this.user_monthly_job_requests = response.data.data;
          this.count = response.data.count;
          // Handle serial number starting point for "ALL" option
          this.serialNoStarting = this.selectedRowsPerPage === -1 ? 0 : (this.page - 1) * this.selectedRowsPerPage;
          // Handle pagination length for "ALL" option
          if (this.selectedRowsPerPage === -1) {
            this.paginationLength = 1;
          } else {
            this.paginationLength = Math.ceil(this.count / this.selectedRowsPerPage);
          }
        })
        .catch((error) => {
          console.log(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(
        `user_monthly_job_request_exports?${query}`
      );
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    getMonthYear() {
      if (this.filter.month_year) {
        this.filter.year = this.filter.month_year.split("-")[0];
        this.filter.month = this.filter.month_year.split("-")[1];
      }
    },
    async Delete_this(id) {
      this.delete_user_monthly_job_request = true;
      await axios
        .post(`/user_monthly_job_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user_monthly_job_request = false;
          this.is_deleted_user_monthly_job_request = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_user_monthly_job_request = true;
      await axios
        .post(`/user_monthly_job_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_user_monthly_job_request = false;
          this.is_restored_user_monthly_job_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    onRowsPerPageChange() {
      this.page = 1; // Reset to first page when changing rows per page
      this.getData();
    },
  },
};
</script>
